import React from "react";
import { FaDiscord, FaBug, FaEnvelopeOpenText } from "react-icons/fa";
import "../style/HomeSections.css";

const highlights = [
  {
    icon: FaDiscord,
    title: "Discord Kyros",
    copy: "Lo usiamo per aggiornamenti rapidi, domande sui giochi e inviti ai playtest quando una build è pronta."
  },
  {
    icon: FaBug,
    title: "Playtest sui nostri giochi",
    copy: "I test restano legati ai giochi Kyros: Zombie Crushers, WarFront e Ghost Hunter, ognuno con il suo stato."
  },
  {
    icon: FaEnvelopeOpenText,
    title: "Aggiornamenti Store",
    copy: "Quando cambiano prezzo, stato di vendita o requisiti, la scheda del gioco e lo Store devono dirlo chiaramente."
  }
];

export default function HomeCommunity() {
  return (
    <section className="home-community">
      <div className="home-section__inner home-community__inner">
        <div className="home-community__lead">
          <span className="home-eyebrow">Community</span>
          <h2>Playtest e community restano legati ai giochi</h2>
          <p>
            Non vogliamo gonfiare il sito con annunci: usiamo Discord per parlare delle build,
            raccogliere problemi reali e preparare i prossimi aggiornamenti.
          </p>
          <a className="home-button home-button--outline" href="/contact">
            Entra in contatto
          </a>
        </div>

        <div className="home-community__grid">
          {highlights.map(item => {
            const Icon = item.icon;
            return (
              <article key={item.title} className="home-community-card">
                <div className="home-community-card__icon">
                  <Icon aria-hidden="true" />
                </div>
                <h3>{item.title}</h3>
                <p>{item.copy}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
